import { ERROR_MESSAGE_FASCIA_PLACEHOLDER, ErrorMessage } from '@as-react/common-types';
import { FacebookErrorsEnum } from '../api/auth/AuthSocialLoginFacebookApi';
export const getLoginError = (error, t, mainWebShop) => {
    if (!error) {
        return null;
    }
    else if (Object.values(ErrorMessage).includes(error)) {
        return t(mainWebShop ? error.replace(ERROR_MESSAGE_FASCIA_PLACEHOLDER, mainWebShop) : error);
    }
    else {
        switch (error) {
            case FacebookErrorsEnum.PERMISSION_EMAIL:
                return t('account:account.social.media.login.error.permission.email.retry');
            case FacebookErrorsEnum.ALREADY_EXIST:
                return t('account:account.social.media.connections.error.already.connected', {
                    platform: 'Facebook',
                });
            case FacebookErrorsEnum.EMAIL_MISMATCH:
                return t('account:account.social.media.login.email.mismatch');
            default:
                return t('account:account.error.general');
        }
    }
};
